<template>
  <div class="aproval_department--container">
    <div class="aproval_department--header">
      <p class="aproval_department--description">Departamentos</p>
      <button v-if="changes.length" @click="saveChanges" >
        Guardar Cambios ({{ changes.length }})
      </button>
    </div>

    <div class="aproval_department--cards">
      <div v-for="dept in paginatedDepartments" :key="dept.id" class="aproval_department--card">
        <div class="aproval_department--card-header" @click="toggle(dept.id)">
          <h2>{{ dept.name }}</h2>
          <span class="aproval_department--arrow" :class="{ 'aproval_department--rotated': expandedId === dept.id }">▼</span>
        </div>

        <div class="aproval_department--card-body" :style="{ maxHeight: expandedId === dept.id ? '500px' : '0px' }">
          <div class="aproval_department--card-selector">
            <button 
              :class="{ 'aproval_department--active': activeView[dept.id] === 'visit' }" 
              @click.stop="setActiveView(dept.id, 'visit')"
            >
              Razones de Visita
            </button>
            <button 
              :class="{ 'aproval_department--active': activeView[dept.id] === 'rejection_reasons' }" 
              @click.stop="setActiveView(dept.id, 'rejection_reasons')"
            >
              Criterios de Aprobación
            </button>
          </div>

          <div class="aproval_department--content">
            <strong>
              {{ activeView[dept.id] === "visit" ? "Razones de Visita:" : "Criterios de Aprobación:" }}
            </strong>
            <ul class="aproval_department--items-list">
              <div class="aproval_department--items-item" v-for="(item, i) in getActiveList(dept.id)" :key="i">
                <template v-if="edittingItem=== item.name">
                  <input v-model="editedValue" class="edit-input" @keyup.enter="saveItem(dept.id, item.name)"  @blur="cancelEdit"/>
                  <span class="aproval_department--icons">
                    <button @click.stop="saveItem(dept.id, item.id)" class="icon-button">
                      <i class="fas fa-check"></i> <!-- Icono de guardar -->
                    </button>
                  </span>
                </template>
                
                <template v-else>
                  {{ item.name }}
                  <span class="aproval_department--icons">
                    <button v-if="item.id" @click.stop="editItem(dept.id, item.name)" class="icon-button">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                    <button @click.stop="deleteItem(dept.id, item.name)" class="icon-button">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </span>
                </template>
              </div>

            </ul>
            <details class="aproval_department--disabled-items"  v-if="getDisabledList(dept.id).length">
              <summary>Mostrar ítems inhabilitados</summary>
              <ul>
                <li v-for="(item, i) in getDisabledList(dept.id)" :key="`disabled-${i}`">
                  {{ item.name }}
                  <button @click="enableItem(dept.id, item.name)" class="restore-button">
                    <i class="fas fa-undo"></i>
                  </button>
                </li>
              </ul>
            </details>
          </div>

          <div class="aproval_department--add-section">
            <input 
              v-if="showInput[dept.id]" 
              v-model="newEntry[dept.id]" 
              placeholder="Agregar nuevo..." 
              ref="inputs"
              @blur="handleBlur(dept.id)" 
            />
            <button @click.stop="toggleInput(dept.id)">
              {{ showInput[dept.id] ? '✔ Agregar' : '+ Añadir' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="aproval_department--table-card-footer">
      <nav class="aproval_department--pagination" role="navigation" aria-label="pagination">
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          @input="changePage"
        />
      </nav>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      expandedId: null,
      activeView: {},
      showInput: {},
      newEntry: {},
      departments: [],
      changes: [],
      currentPage: 1,
      perPage: 10, // Número de departamentos por página
      edittingItem:"",
      editedValue: "", // Para almacenar el nuevo valor temporalmente
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.departments.length / this.perPage);
    },
    paginatedDepartments() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.departments.slice(start, start + this.perPage);
    },
  },
  methods: {
    cancelEdit() {
    this.edittingItem = null; // Restablece el estado para salir del modo edición
  },
    toggle(deptId) {
      this.expandedId = this.expandedId === deptId ? null : deptId;
    },
    setActiveView(deptId, view) {
      this.$set(this.activeView, deptId, view);
    },
    getActiveList(deptId) {
      const department = this.departments.find(d => d.id === deptId);
      if (!department) return [];

      const list = this.activeView[deptId] === "visit" 
        ? department.visit_reasons || [] 
        : department.rejection_reasons || [];

      return list.filter(item => item.status === true);
    },
    toggleInput(deptId) {
      if (this.showInput[deptId]) {
        this.addEntry(deptId);
      } else {
        this.$set(this.showInput, deptId, true);
        this.$nextTick(() => {
          if (this.$refs.inputs && this.$refs.inputs[deptId]) {
            this.$refs.inputs[deptId].focus();
          }
        });
      }
    },
    addEntry(deptId) {
      if (this.newEntry[deptId] && this.newEntry[deptId].trim()) {
        const type = this.activeView[deptId] === "visit" ? "visit_reasons" : "rejection_reasons";
        const newItemName = this.newEntry[deptId].trim();

        const department = this.departments.find(d => d.id === deptId);
        if (!department) return;

        // Verificar si el nombre ya existe en la lista
        const exists = department[type].some(item => item.name.toLowerCase() === newItemName.toLowerCase());
        if (exists) {
          alert("El nombre ya existe en la lista.");
          return;
        }

        const newItem = { name: newItemName, status: true };
        department[type].push(newItem);
        this.newEntry[deptId] = "";
        this.$set(this.showInput, deptId, false);

        this.trackChanges(deptId, type, newItem);
      }
    }
    ,
    editItem(deptId, itemName) {
    this.edittingItem = itemName;
    },
    saveItem(deptId, itemId) {
      if(!this.editedValue){
        alert("pofavor ingrese un valor")
        this.edittingItem=""
        return
      }
      const type = this.activeView[deptId] === "visit" ? "visit_reasons" : "rejection_reasons";
      const department = this.departments.find(d => d.id === deptId);
      if (!department || !department[type]) return;

      const items = department[type];
      const index = items.findIndex(item => item.id === itemId);
      if (index === -1) return;

      const item = items[index];

      item.name = this.editedValue;
      this.edittingItem = "";
      this.editedValue = "";


      this.trackChanges(deptId, type, item);
    },
    deleteItem(deptId, itemname) {
      const type = this.activeView[deptId] === "visit" ? "visit_reasons" : "rejection_reasons";
      const department = this.departments.find(d => d.id === deptId);
      if (!department || !department[type]) return;

      const items = department[type];
      const index = items.findIndex(item => item.name === itemname);
      if (index === -1) return;

      const item = items[index];

      if (!item.id) {
        console.log(this.changes)
        // Eliminar el item de `departments`

        // Verificar si `changes` contiene el departamento y tipo antes de modificarlo
        const deptName = department.name;
        const changesDept = Object.keys(this.changes).find(key => this.changes[key].name === deptName);

        if (changesDept) {
          console.log(this.changes)
          if (this.changes[changesDept][type]) {
            this.changes[changesDept][type] = this.changes[changesDept][type].filter(changedItem => changedItem.name !== itemname);
          }

          // Si ambos arrays quedan vacíos, eliminar el departamento de `changes`
          const hasVisitReasons = this.changes[changesDept].visit_reasons && this.changes[changesDept].visit_reasons.length > 0;
          const hasRejectionReasons = this.changes[changesDept].rejection_reasons && this.changes[changesDept].rejection_reasons.length > 0;
          
          if (!hasVisitReasons && !hasRejectionReasons) {
            delete this.changes[changesDept];
            if (Object.keys(this.changes).length === 0) {
                this.changes = [];
            }
          }
        }

        items.splice(index, 1);
  
      } else {
        item.status = false;
        this.trackChanges(deptId, type, { ...item });
      }
    }
    ,
    handleBlur(deptId) {
      if (!this.newEntry[deptId] || !this.newEntry[deptId].trim()) {
        this.$set(this.showInput, deptId, false);
        this.newEntry[deptId] = "";
      }
    },
    trackChanges(deptId, type, newItem) {
        const department = this.departments.find(d => d.id === deptId);
        if (!department) return; // Evita errores si el departamento no existe

        // Buscar si ya hay un cambio registrado para este departamento
        let existingChange = this.changes.find(change => change.id === deptId);

        if (!existingChange) {
          // Si no hay cambios previos, creamos una nueva entrada
          existingChange = {
            id: deptId,
            name: department.name,
            visit_reasons: [],
            rejection_reasons: []
          };
          this.changes.push(existingChange);
        }

        // Asegurar que el array del tipo correspondiente existe
        if (!Array.isArray(existingChange[type])) {
          this.$set(existingChange, type, []);
        }

        // Buscar si el item ya existe en el array de cambios (comparando por `name`)
        const existingItem = existingChange[type].find(item => item.name === newItem.name);

        if (existingItem) {
          // Si ya existe, actualizarlo sin sobrescribir todo el objeto
          Object.assign(existingItem, newItem);
        } else {
          // Si no existe, agregarlo asegurando reactividad con Vue
          this.$set(existingChange[type], existingChange[type].length, { ...newItem });
        }
      },

      getDisabledList(deptId) {
        const department = this.departments.find(d => d.id === deptId);
        if (!department) return [];
        const type = this.activeView[deptId] === "visit" ? "visit_reasons" : "rejection_reasons";
        return department[type].filter(item => !item.status); // Filtra los inhabilitados
      },
      
      enableItem(deptId, itemName) {
        const department = this.departments.find(d => d.id === deptId);
        if (!department) return;
        const type = this.activeView[deptId] === "visit" ? "visit_reasons" : "rejection_reasons";
        const item = department[type].find(it => it.name === itemName);
        if (item) item.status = true; // Habilita el ítem

        this.trackChanges(deptId, type, item);
      }



    ,
    async saveChanges() {
      if (!this.changes.length) return; // No hacer la petición si no hay cambios
      console.log(this.changes)



      try {
        const response = await this.$http.patch(
          "approval_department/bulk_update_reasons",
          { departments: this.changes }, // Cuerpo de la petición
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          }
        );

        console.log("Cambios guardados correctamente:", response.body);
        this.changes = []; // Limpiar cambios tras el éxito
      } catch (error) {
        console.error("Error al guardar cambios:", error);
        alert("Hubo un error al guardar los cambios.");
      }
    }
    ,
    get_departments_data() {
      try {
        this.$http
          .get("approval_department/visit_criteria", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId(),
                company_id: this.getCompany().id
              }
            }
          })
          .then(response => {
            this.departments = response.body.approval_departments;
            this.departments.forEach((dept) => {
              this.$set(this.activeView, dept.id, "visit");
              this.$set(this.showInput, dept.id, false);
              this.$set(this.newEntry, dept.id, "");
            });
          });
      } catch (e) {
        alert(e);
      }
    },
    changePage(page) {
      this.currentPage = page;
    }
  },
  mounted() {
    this.get_departments_data();
  }
};
</script>





// WEBPACK FOOTER //
// src/components/views/invitations/business_invitations/DepartmentsOverview.vue